import { CALL_API } from 'assets/js/apiMiddleware'
import { actionTypes } from 'assets/js/actionTypes'
import { getToken, setCredentials, setHashCode } from 'assets/js/auth'
import axios from 'assets/js/axios'

export const loginActions = actionTypes('POST_USER')

export default function(state = {}, action = []) {
  switch (action.type) {
    case loginActions.BEGIN:
      return { ...state, loadingUser: true, isAuthenticated: false }
    case loginActions.SUCCESS:
      const { jwttoken, account } = action.response
      return {
        ...state,
        token: jwttoken,
        user: { ...account },
        loadingUser: false,
        isAuthenticated: true
      }
    case loginActions.ERROR:
      return { ...state, loadingUser: false, isAuthenticated: false }
    default:
      return state
  }
}

export const authenticate = (
  { username, password, hashCode, overwriteHashCode },
  message
) => {
  return dispatch => {
    return dispatch({
      [CALL_API]: {
        type: loginActions,
        endpoint: '/accounts/authenticate',
        method: 'post',
        data: { username, password }
      }
    }).then(data => {
      if (!data) {
        message('Usuário não encontrado ou senha incorreta.')
      }

      if (data && data.type && data.type !== loginActions.ERROR) {
        const { jwttoken, account } = data.response
        const headers = {
          Authorization: `Bearer ${jwttoken}`
        }
        setCredentials(jwttoken, account)

        if (account.organization && typeof account.organization === 'object') {
          localStorage.setItem('organizationId', account.organization.id);
        }
        else if (account.organizationId) {
          localStorage.setItem('organizationId', account.organizationId);
        }
        else if (typeof account.organization === 'string') {
          localStorage.setItem('organizationId', account.organization);
        }

        axios
          .get(`/accounts/authenticate/hash-code?hashCode=${hashCode}`, {
            headers: headers
          })
          .then(() => {
            setHashCode(hashCode)
          })
          .catch(() => {
            message('Token de sessão inválido.')
          })
      }
    })
  }
}

export const validateHashCode = (
  overwriteHashCode,
  hashCode,
  messageFunction
) => {
  const jwttoken = getToken()
  const headers = {
    Authorization: `Bearer ${jwttoken}`
  }

  if (overwriteHashCode) {
    axios
      .post(
        `/accounts/authenticate/hash-code?hashCode=${hashCode}`,
        {},
        {
          headers: headers
        }
      )
      .then(() => {
        setHashCode(hashCode)
      })
      .catch(() => {
        return messageFunction('Erro ao iniciar sessão.')
      })
  } else {
    axios
      .get(`/accounts/authenticate/hash-code?hashCode=${hashCode}`, {
        headers: headers
      })
      .then(() => {
        setHashCode(hashCode)
      })
      .catch(() => {
        return messageFunction('Token de sessão inválido.')
      })
  }
}
